import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppSettingsType } from '@core/services/common/app-settings-loader.service';
import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';
import { b2cPolicies, msalConfig, protectedResourceScopes } from './app/auth-config';

async function setDynamicEnvironments() {
  try {
    if (environment.isLocalWeb) {
      const response = await fetch(EndpointConstants.ApiEdgeSettings);
      const config: AppSettingsType = await response.json();

      environment.B2C_tenantName = config.b2C_tenantName;
      environment.B2C_clientId = config.b2C_clientId;
      environment.B2C_signout = config.b2C_signout;
      environment.B2C_SSO_invite = config.b2C_SSO_invite;
      environment.B2C_signInPolicy = config.b2C_signInPolicy;
      environment.B2C_signUpPolicy = config.b2C_signUpPolicy;
      environment.apimSubscriptionKey = config.apimSubscriptionKey;
      environment.urlWebSocketRemoteSupport = config.urlWebSocketRemoteSupport;
      environment.remoteSupportSubscriptionKey = config.remoteSupportSubscriptionKey;

      b2cPolicies.authorities.signIn.authority = `https://${environment.B2C_tenantName}.b2clogin.com/${environment.B2C_tenantName}.onmicrosoft.com/${environment.B2C_signInPolicy}`;
      b2cPolicies.authorityDomain = `${environment.B2C_tenantName}.b2clogin.com`;

      protectedResourceScopes[0] = `https://${environment.B2C_tenantName}.onmicrosoft.com/b2c-api/b2c.read`;

      msalConfig.auth = {
        clientId: environment.B2C_clientId,
        authority: b2cPolicies.authorities.signIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: environment.B2C_redirectUri,
      };
    }
  } catch (error) {
    console.error(error);
  }
}

(async () => {
  await setDynamicEnvironments();

  // Save deep link URL before Angular bootstraps (guards may redirect)
  // Only save if ApplicationGuid is not set — otherwise the user was already in the app and just refreshed
  const initialPath = window.location.pathname + window.location.search;
  const ignoredPaths = [
    '/',
    '/home',
    '/login',
    '/company',
    '/businessplans',
    '/logout',
    '/register',
    '/recoverpassword',
    '/resetpassword',
  ];
  const appGuid = sessionStorage.getItem('ApplicationGuid');
  const hasAppContext = appGuid && appGuid !== '' && appGuid.toUpperCase() !== '00000000-0000-0000-0000-000000000000';
  if (initialPath && !ignoredPaths.includes(window.location.pathname) && !hasAppContext) {
    sessionStorage.setItem('deepLinkReturnUrl', initialPath);
    sessionStorage.setItem('deepLinkAttempts', '0');
  }

  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
})();
